import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError, LOGO_URL } from "../lib/api";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, new_password: password });
      toast.success(data.message);
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-6">
      <div className="w-full max-w-sm rounded-md border border-slate-200 bg-white p-8 fade-in-up">
        <img src={LOGO_URL} alt="DCN" className="h-14 w-auto" />
        <h1 className="mt-4 text-xl font-bold text-slate-900">Set a new password</h1>
        {!token ? (
          <p data-testid="reset-no-token-message" className="mt-4 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
            Missing reset token. Use the reset link shared by your admin.
          </p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">New Password</label>
              <input data-testid="reset-password-input" type="password" required minLength={6} value={password}
                onChange={(e) => setPassword(e.target.value)} placeholder="Min 6 characters"
                className="mt-1 w-full rounded-md border border-slate-300 px-3 py-2 text-sm outline-none transition-colors duration-150 focus:border-slate-900" />
            </div>
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Confirm Password</label>
              <input data-testid="reset-confirm-input" type="password" required minLength={6} value={confirm}
                onChange={(e) => setConfirm(e.target.value)} placeholder="Repeat password"
                className="mt-1 w-full rounded-md border border-slate-300 px-3 py-2 text-sm outline-none transition-colors duration-150 focus:border-slate-900" />
            </div>
            {error && <p data-testid="reset-error" className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}
            <button data-testid="reset-submit-button" type="submit" disabled={loading}
              className="w-full rounded-md bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-slate-700 disabled:opacity-60">
              {loading ? "Saving…" : "Reset password"}
            </button>
          </form>
        )}
        <Link to="/login" className="mt-4 block text-sm text-slate-500 underline-offset-4 hover:underline">
          ← Back to sign in
        </Link>
      </div>
    </div>
  );
}
